







import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class NoDataPanel extends Vue {
  @Prop({ default: 'データがまだありません 🤔' })
  message!: string;
}
